module.exports = __webpack_public_path__ + "static/media/dark-icon-success.a785c6c2.png";